<script>
import {months, last4Years, currentYear, currentMonth} from "@/helpers/months";
import ComplaintForm from "@components/support-areas/internal-control/condusef/complaint-reports/complaint-form.vue";

export default {
  name: "complaint-reports",
  components: {ComplaintForm},
  data: () => ({
    complaints: [],
    yearSelected: null,
    monthSelected: null,
    showComplaintModal: false,
    months
  }),
  computed: {
    last4Years,
    currentYear,
    currentMonth,
  },
  mounted() {
    this.yearSelected = this.currentYear;
    this.monthSelected = this.currentMonth - 1;

    this.fetchComplaints();
  },
  methods: {
    async fetchComplaints() {
      this.$vs.loading();
      try {
        const response = await axios.get(`/api/condusef/redeco/complaint?year=${this.yearSelected}&month=${this.monthSelected}`);
        this.complaints = response.data;
        this.$vs.loading.close();
      } catch (e) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Error",
          text: e.response.data.error,
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle"
        });
      }
    },
    async deleteComplaintHandler(complaint) {
      this.$vs.loading();
      try {
        await axios.post(`/api/condusef/redeco/complaint/delete`, {folio: complaint.folio});
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Éxito",
          text: "Queja eliminada correctamente",
          color: "success",
          iconPack: "feather",
          icon: "icon-check"
        });
        await this.fetchComplaints()
      } catch (e) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Error",
          text: e.response.data.error,
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle"
        });
      }
    }
  },
}
</script>

<template>
  <div class="container mt-10">
    <span class="px-5 pill-secondary pulse-secondary">Producción</span>

    <vx-card title="Reporte de quejas (REDECO API)" class="mt-5">
      <div class="flex flex-col md:flex-row items-center justify-between gap-4">
        <div class="flex items-end gap-4">
          <vs-select label="Año" v-model="yearSelected">
            <vs-select-item
                v-for="year in last4Years"
                :key="year"
                :value="year"
                :text="year"></vs-select-item>
          </vs-select>
          <vs-select v-model="monthSelected" label="Mes">
            <vs-select-item
                v-for="month in months"
                :key="month.value"
                :value="month.value"
                :text="month.text"></vs-select-item>
          </vs-select>

          <vs-button icon="search" @click="fetchComplaints" class="mb-1"></vs-button>
        </div>
        <div>
          <vs-button @click="showComplaintModal = true" class="small">
            Nueva queja
          </vs-button>
        </div>
      </div>

      <div class="mt-5">
        <vs-table :data="complaints.quejas"
                  no-data-text="No hay quejas disponible para visualizar en la fecha indicada">
          <template slot="thead">
            <vs-th>Folio</vs-th>
            <vs-th>Institución clave</vs-th>
            <vs-th>Opciones</vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :key="index" v-for="(complaint, index) in data">
              <vs-td>{{ complaint.folio }}</vs-td>
              <vs-td>{{ complaint.institucionClave }}</vs-td>
              <vs-td>
                <vs-button @click="deleteComplaintHandler(complaint)" color="danger" class="small">
                  Eliminar
                </vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>

    <vs-popup fullscreen :active.sync="showComplaintModal" title="Crear una nueva queja">
      <complaint-form @onSaved="() => {}" />
    </vs-popup>

  </div>
</template>

<style scoped>

</style>